import MessageBlurbText from "./MessageBlurbText";

const MessageBlurbTextBold = (props) => {
  return <MessageBlurbText {...props} bold />;
};

export default MessageBlurbTextBold;
